import { useEffect } from "react";
import { firebaseAuth } from "../../api/firebase/firestoreService";
import RisaLogoWhite from "../../svg/risa-logo-white";
import { clearAllFromLocalStorage } from "../../utils/localStorageHelper";
import MagicLink from "../userAuthentication/magicLink/magicLink";

const NewUserAuthentication = () => {
  // Clear all local storage and sign out user when user navigates to this page
  useEffect(() => {
    clearAllFromLocalStorage();
    const signOutUser = async () => {
      try {
        await firebaseAuth.signOut();
      } catch (error) {
        console.error("Error signing out:", error);
      }
    };
    signOutUser();

    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <>
      <div className="mb-10 h-screen w-screen bg-black">
        <div className="flex h-5/6 w-full flex-col items-center justify-center gap-16 bg-black">
          <div className="">
            <RisaLogoWhite />
          </div>
          <div className="w-1/4 rounded-lg bg-white p-3">
            <MagicLink />{" "}
          </div>
          <div className="mt-16 flex w-1/3 flex-col items-center justify-center">
            <div className="w-full text-center text-white">
              Need Help? <span>Contact Us</span>
            </div>
            <div className="version-info mt-2 text-center text-xs text-primaryGray-5">
              Version : {process.env.REACT_APP_VERSION}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewUserAuthentication;
